import { NgModule } from '@angular/core';
import { UtilsModule } from '@app/blocks/utils';
import { SharedModule } from '@shared';

import { AuthRoutingModule } from './auth-routing.module';

@NgModule({
  declarations: [AuthRoutingModule.declarations],
  imports: [SharedModule, AuthRoutingModule, UtilsModule],
})
export class AuthModule {}
